module.exports = __webpack_public_path__ + "img/9-1_03.b6206a98.jpg";